import { dataTrendDesktopSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconTrendDesktopSolid = /*#__PURE__*/createIcon(dataTrendDesktopSolid)
export default IconTrendDesktopSolid
